export default {
  apiError: {},
  stripePublishableKey: '',
  facebookAppId: '',
  googleApiKey: '',
  pusherApiKey: '',
  googleMapsSecret: '',
  onesignalAppId: '',
  sendbeeDevelopersDocs: '',
  pusherChannels: {},
  pusherAuthEndpoint: '',
  webApiRoot: '',
  waSettings: null,
  contactFilterLimits: {
    maxNumberOfBlocks: 2,
  },
  contactImportLimits: {
    maxNumberOfContacts: 10000,
  },
  maxBroadcastNumbers: 0,
  showAnnouncement: !localStorage.getItem('feature:ios:2'),
};
